import React from 'react';
import { Box, Typography } from '@mui/material';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';

const Footer = () => {
  return (
    <footer
        className="text-white py-4"
        style={{ fontFamily: 'Nunito, sans-serif', backgroundColor: '#09274A' }}
      >

        <Box
          display="grid"
          gridTemplateColumns={{ xs: '1fr', md: '1fr auto 1fr' }}
          alignItems="center"
          px={{ xs: 2, sm: 4, md: 8 }}
          gap={4}
          textAlign="center"
        >

      {/* Izquierda */}
      <Box display="flex" flexDirection="column" alignItems={{ xs: 'center', md: 'flex-start' }}>
        <Typography
          variant="body2"
          component="a"
          href="https://cidere.cl/"
          target="_blank"
          rel="noopener noreferrer"
          className="mt-1 hover:underline hover:text-[#0488AF]"
          sx={{ color: 'inherit' }}
        >
          Página oficial
        </Typography>
        <Typography variant="body2" className="mt-1">
          &copy; 2025 CIDERE. Todos los derechos reservados.
        </Typography>
        <Typography variant="body2" className="mt-1" sx={{ textDecoration: 'underline' }}>
          Desarrollado por Proyectos Capstone EIC UCN COQUIMBO
        </Typography>
      </Box>

      {/* Centro */}
      <Box display="flex" flexDirection="column" alignItems="center">
        <a href="https://cidere.cl/" target="_blank" rel="noopener noreferrer">
          <img
            src="/LogoCIDEREblancoHorizontal.png"
            alt="Logo CIDERE"
            className="max-w-[200px] h-12 w-auto"
          />
        </a>
        <Typography variant="body2" className="mt-1">
          RED DE SOCIOS
        </Typography>
      </Box>

      {/* Derecha */}
      <Box display="flex" flexDirection="column" alignItems={{ xs: 'center', md: 'flex-end' }} textAlign={{ xs: 'center', md: 'right' }}>
      <Typography variant="body2" display="flex" alignItems="center" gap={1}>
          <PhoneIcon fontSize="small" />
          +56 9 5728 8408
        </Typography>
        <Typography
          variant="body2"
          display="flex"
          alignItems="center"
          gap={1}
          className="mt-1"
          component="a"
          href="mailto:cidere@cidere.cl"
          sx={{ color: 'inherit', textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}
        >
          <EmailIcon fontSize="small" />
          cidere@cidere.cl
        </Typography>
      </Box>

      </Box>
    </footer>
  );
};

export default Footer;
